const Products = [
    {
      id: 1,
      name: `AIR ALPHA FORCE 88`,
      price: '11895',
      imageSrc: 'https://www.superkicks.in/cdn/shop/files/2_6e5eeb3d-30d9-4bc1-9845-75d0ca64639c.jpg?v=1697712399&width=720',
      imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
      Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
    },
    {
      id: 2,
      name: `FREAK 5 EP 'PLATINUM'`,
      price: '8000',
      imageSrc: 'https://www.superkicks.in/cdn/shop/files/2_98.jpg?v=1700227722&width=720',
      imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
      Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
    },
    {
      id: 3,
      name: `DUNK LOW TWIST`,
      price: '9500',
      imageSrc: 'https://cdn.shopify.com/s/files/1/0659/0722/8923/files/2_886ff3cd-eca0-46a4-9d88-d7e0a0b49f48_1000x.jpg?v=1705997206',
      imageAlt: 'Person using a pen to cross a task off a productivity paper card.',
      Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
    },
    {
        id: 4,
        name: `PLEXUS SAND 'IVORY GRAY'`,
        price: '9000',
        imageSrc: 'https://cdn.shopify.com/s/files/1/0659/0722/8923/files/2_58aa6a3c-14a8-4538-a343-ec64775e0dc7.jpg?v=1697197817&width=720',
        imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
        Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
      },
      {
        id: 5,
        name: `180 STAPLE 'GRANOLA-ALPINE'`,
        price: '14000',
        imageSrc: 'https://cdn.shopify.com/s/files/1/0659/0722/8923/files/2_79de3148-c0e8-4a5a-850e-59c92beff095.jpg?v=1710831981&width=720',
        imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
      Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
      },
      {
        id: 6,
        name: `RS-X EFEKT ENERGY `,
        price: '8500',
        imageSrc: 'https://cdn.shopify.com/s/files/1/0659/0722/8923/files/3_90ccc849-8af8-4dcd-86d7-1677c8515c91.jpg?v=1692621299&width=720',
        imageAlt: 'Person using a pen to cross a task off a productivity paper card.',
        Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
      },
      
      {
        id: 7,
        name: `FORUM MOD LOW `,
        price: '11500',
        imageSrc: 'https://cdn.shopify.com/s/files/1/0659/0722/8923/files/2_ffd36193-ca82-4536-a376-2742998e2c0f.jpg?v=1708951959&width=720',
        imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
        Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
      },
      {
        id: 8,
        name: `FORUM MOD MID `,
        price: '7800',
        imageSrc: 'https://www.superkicks.in/cdn/shop/files/2_39570f3e-f3af-46b6-9e4c-e4b75a881612.jpg?v=1691141762&width=720',
        imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
        Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
      },
      {
        id: 9,
        name: `NITEBALL 'OFF WHITE/CLOUD WHITE'`,
        price: '9000',
        imageSrc: 'https://www.superkicks.in/cdn/shop/files/2_ea724d59-aed5-4631-b25d-ba90a0a1ebed.jpg?v=1694606869&width=720',
        imageAlt: 'Person using a pen to cross a task off a productivity paper card.',
        Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
      },
      
      {
        id: 10,
        name: `BB550 VGA 'RED/WHITE'`,
        price: '13000',
        imageSrc: 'https://cdn.shopify.com/s/files/1/0659/0722/8923/files/2_4bd3f6e2-625c-4f62-8625-3a2eb1d5fe44_1000x.jpg?v=1710510556',
        imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
        Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
      },
      {
        id: 11,
        name: `BB550 'CHROME BLUE'`,
        price: '13000',
        imageSrc: 'https://cdn.shopify.com/s/files/1/0659/0722/8923/files/2_c1935578-e4e1-491c-bb28-6c9063d27510_1000x.jpg?v=1710770092',
        imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
        Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
      },
      {
        id: 12,
        name: `550 VINTAGE TEAL`,
        price: '13000',
        imageSrc: 'https://crepdogcrew.com/cdn/shop/files/2_12998cf5-9717-4601-b185-137be6d2072f.png?v=1704709627&width=800',
        imageAlt: 'Person using a pen to cross a task off a productivity paper card.',
        Size1:8,
      Size2:9,
      Size3:10,
      Size4:11,
      },
  ]
  export default Products;